var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"py-1"},[_c('v-col',{staticClass:"col-4 py-0"},[_c('label',{staticClass:"label",class:{ 'label-high': _vm.height === 'high' }},[_vm._v(_vm._s(_vm.$t(_vm.path)))])]),_c('v-col',{staticClass:"col-8 py-0"},[_c('span',[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }